import Cookies from 'js-cookie';

import { getAdsMarketingConsent } from '@/shared/lib/adsConsent';

export { ADS_CONSENT_EVENTS as OPENAI_ADS_CONSENT_EVENTS } from '@/shared/lib/adsConsent';

export type OpenAiAdsContext = {
  marketing_consent: boolean;
  obref?: string;
  observed_at: string;
  oppref?: string;
};

export const getOpenAiAdsContext = (): OpenAiAdsContext | undefined => {
  const observed_at = new Date().toISOString();
  const consent = getAdsMarketingConsent();
  if (consent === undefined) return;
  if (!consent) return { marketing_consent: false, observed_at };
  const oppref = new URLSearchParams(window.location.search).get('oppref') || Cookies.get('__oppref');
  const obref = Cookies.get('__obref');
  return {
    marketing_consent: true,
    observed_at,
    ...(oppref && oppref.length <= 2048 && { oppref }),
    ...(obref && obref.length <= 256 && { obref }),
  };
};
